import { EMPTY_LIST } from '../../../../../constants/common'
import {
  toFlatSelectItems,
  toFlatWithBuildingSelectItem,
} from '../../../../Flat'
import { getFlats } from '../../../EmailRecipientsField'
import {
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING,
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT,
} from '../EmailCopyToEntityFilterModal.constants'

export function getEmailCopyToEntityFilterModalFieldsFlatApiParams(
  buildings = EMPTY_LIST
) {
  return {
    building: buildings.map(item => ['building', item.value]),
  }
}

export function getEmailCopyToEntityFilterModalFieldsFlats(apiParams) {
  return getFlats(apiParams)
}

export function toEmailCopyToEntityFilterModalFieldsFlatSelectItems(items) {
  return toFlatSelectItems(items, toFlatWithBuildingSelectItem)
}

export function filterEmailCopyToEntityFilterModalFieldsFlatOptions({
  [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING]:
    buildings = EMPTY_LIST,
  [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT]: flats = EMPTY_LIST,
}) {
  const buildingIds = buildings.map(building => building.value)

  return flats.filter(flat => buildingIds.includes(flat.building?.id))
}
